import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
// hooks
import useAuth from '../hooks/useAuth';
// routes
import { PATH_AUTH, PATH_DASHBOARD } from '../routes/paths';
// components
import LoadingScreen from '../components/LoadingScreen';

// ----------------------------------------------------------------------
// Staff sign-in: /auth/change-password is only for a signed-in person who
// must still choose their own password. Anyone else goes where they belong.
// ----------------------------------------------------------------------

export default function PasswordChangeGuard({ children }: { children: ReactNode }) {
  const { isAuthenticated, isInitialized, mustChangePassword } = useAuth();

  if (!isInitialized) {
    return <LoadingScreen />;
  }

  if (!isAuthenticated) {
    return <Navigate to={PATH_AUTH.login} replace />;
  }

  if (!mustChangePassword) {
    return <Navigate to={PATH_DASHBOARD.root} replace />;
  }

  return <>{children}</>;
}
